import { render, staticRenderFns } from "./SendSingle.vue?vue&type=template&id=368da974&scoped=true"
import script from "./SendSingle.vue?vue&type=script&lang=js"
export * from "./SendSingle.vue?vue&type=script&lang=js"
import style0 from "./SendSingle.vue?vue&type=style&index=0&id=368da974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368da974",
  null
  
)

export default component.exports